"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defValidation = defValidation;
exports.validateAttr = validateAttr;
exports.validateRule = validateRule;
exports.escapePath = escapePath;
exports.getValidationDeps = getValidationDeps;
exports.compact = compact;
exports.ValidationPromise = void 0;

var _getLookup = _interopRequireDefault(require("get-lookup"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var validationRules = {};

function defValidation(name, ruleFn) {
  validationRules[name] = ruleFn;
}

function validateAttr(validations, options, name, value, justDropError) {
  return callValueValidator(validations, options, name, value, justDropError);
}

function validateRule(validations, options, name, errors, justDropError, aggregateErrors, skippedInputNames) {
  if (name.includes('*') || /\([^.]+\)/.test(name)) {
    callEachValidator(validations, options, name, errors, justDropError, aggregateErrors, skippedInputNames);
  } else {
    errors[name] = callValueValidator(validations, options, name, (0, _getLookup["default"])(options.attrs, name), justDropError, aggregateErrors, skippedInputNames);
  }
}

function callEachValidator(validations, options, name, errors, justDropError, aggregateErrors, skippedInputNames) {
  var match = name.match(/^([^*()]+)\.(?:\*|(\([^.]+\)))?(.+)?$/);

  var _match$slice = match.slice(1),
      _match$slice2 = _slicedToArray(_match$slice, 3),
      collectionName = _match$slice2[0],
      capture = _match$slice2[1],
      _match$slice2$ = _match$slice2[2],
      rest = _match$slice2$ === void 0 ? '' : _match$slice2$;

  ((0, _getLookup["default"])(options.attrs, collectionName) || []).forEach(function (_item, i) {
    var fullOptions = capture ? _objectSpread(_objectSpread({}, options), {}, _defineProperty({}, capture.substring(1, capture.length - 1), i)) : options;
    validateRule(validations, fullOptions, "".concat(collectionName, ".").concat(i).concat(rest), errors, justDropError, aggregateErrors, skippedInputNames);
  });
}

function callValueValidator(validations, options, name, value, justDropError, aggregateErrors, skippedInputNames) {
  if (skippedInputNames !== null && skippedInputNames !== void 0 && skippedInputNames.includes(name)) return;

  var _findValidator = findValidator(validations, name, options),
      _findValidator2 = _slicedToArray(_findValidator, 2),
      validator = _findValidator2[0],
      captures = _findValidator2[1];

  return callValidator(validator, value, _objectSpread(_objectSpread(_objectSpread({}, options), captures), {}, {
    name: name
  }), justDropError, aggregateErrors);
}

function callValidator(validator, value, options, justDropError, aggregateErrors) {
  if (justDropError) {
    return null;
  }

  if (Array.isArray(validator)) {
    return callArrayValidator(validator, value, options, aggregateErrors);
  }

  if (typeof validator === 'string') {
    return callStringValidator(validator, value, options);
  }

  if (typeof validator === 'function') {
    return validator(value, options);
  }

  if (validator && _typeof(validator) === 'object') {
    return callObjectValidator(validator, value, options, aggregateErrors);
  }
}

function callArrayValidator(ary, value, options, aggregateErrors) {
  var errors = [];

  for (var i = 0; i < ary.length; i++) {
    var error = callValidator(ary[i], value, options, false, aggregateErrors);

    if (error) {
      if (aggregateErrors) {
        errors.push(error);
      } else {
        return error;
      }
    }
  }

  return aggregateErrors ? errors.flat() : undefined;
}

function callStringValidator(name, value, options) {
  return callValidator(stringToValidator(name), value, options);
}

function callObjectValidator(obj, value, options, aggregateErrors) {
  var errors = [];

  for (var name in obj) {
    if (!obj[name]) continue;
    var validatorOpts = _typeof(obj[name]) === 'object' ? obj[name] : {};
    var error = callStringValidator(name, value, _objectSpread(_objectSpread({}, options), validatorOpts));

    if (error) {
      if (aggregateErrors) {
        errors.push(error);
      } else {
        return error;
      }
    }
  }

  return aggregateErrors ? errors : undefined;
}

function stringToValidator(name) {
  var validator = validationRules[name];
  if (!validator) throw new Error("".concat(name, " validation rule is not defined"));
  return validator;
}

function findValidator(validations, name, _ref) {
  var attrs = _ref.attrs;
  return Object.entries(validations).reduce(function (_ref2, _ref3) {
    var _name$match;

    var _ref4 = _slicedToArray(_ref2, 2),
        toValidate = _ref4[0],
        captures = _ref4[1];

    var _ref5 = _slicedToArray(_ref3, 2),
        path = _ref5[0],
        validator = _ref5[1];

    var pathPattern = escapePath(path).replace(/\\\*|\\\([^.]+\\\)/g, '(\\d+)');
    var inputNameMatch = (_name$match = name.match(new RegExp("^".concat(pathPattern, "$")))) === null || _name$match === void 0 ? void 0 : _name$match.slice(1);

    if (inputNameMatch && isValidatableCollectionPath(path, attrs, inputNameMatch)) {
      var _path$match;

      (_path$match = path.match(/\*|\([^.]+\)/g)) === null || _path$match === void 0 ? void 0 : _path$match.forEach(function (capture, i) {
        var captureName = capture !== '*' && capture.substring(1, capture.length - 1);

        if (captureName) {
          captures[captureName] = +inputNameMatch[i];
        }
      });
      toValidate.push(validator);
    }

    return [toValidate, captures];
  }, [[], {}]);
}

function isValidatableCollectionPath(path, attrs, inputNameMatch) {
  var i = 0;
  return path.split('.').reduce(function (pathTaken, part) {
    if (pathTaken === false) return false;

    if (part === '*' || /\([^.]+\)/.test(part)) {
      var _get;

      var collectionIndex = +inputNameMatch[i++];

      if (((_get = (0, _getLookup["default"])(attrs, pathTaken)) === null || _get === void 0 ? void 0 : _get.length) <= collectionIndex) {
        return false;
      }

      return "".concat(pathTaken, ".").concat(collectionIndex);
    } else {
      return pathTaken ? "".concat(pathTaken, ".").concat(part) : part;
    }
  }, '');
}

function escapePath(path) {
  return path.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getValidationDeps(allDeps, inputName) {
  return Object.keys(allDeps).reduce(function (deps, depName) {
    var inputParts = inputName.split('.');
    var depNameParts = depName.split('.');
    var depRegexp = new RegExp("^".concat(escapePath(depName).replace(/\\[\^*]/g, '\\d+'), "$"));

    if (depRegexp.test(inputName)) {
      allDeps[depName].forEach(function (dep) {
        var depParts = dep.split('.');

        if (inputParts.length > depParts.length) {
          deps.push(dep);
        } else {
          var pinnedDep = depParts.map(function (part, i) {
            return depNameParts[i] === '^' ? inputParts[i] : part;
          }).join('.');
          deps.push(pinnedDep);
        }
      });
    }

    return deps;
  }, []);
}

function compact(errorsObject) {
  var errors = {};

  for (var key in errorsObject) {
    if (errorsObject[key]) {
      errors[key] = errorsObject[key];
    }
  }

  return errors;
}

var ValidationPromise = /*#__PURE__*/function () {
  function ValidationPromise(fn) {
    var _this = this;

    _classCallCheck(this, ValidationPromise);

    this.promise = new Promise(fn).then(function (attrs) {
      _this.success = true;
      return attrs;
    }, function (errors) {
      _this.errors = errors;
    });
  }

  _createClass(ValidationPromise, [{
    key: "then",
    value: function then(fn) {
      var _this2 = this;

      this.promise = this.promise.then(function (result) {
        if (_this2.success) {
          return fn(result);
        }
      });
      return this;
    }
  }, {
    key: "catch",
    value: function _catch(fn) {
      var _this3 = this;

      this.promise = this.promise.then(function () {
        if (_this3.errors) {
          fn(_this3.errors);
        }
      });
      return this;
    }
  }]);

  return ValidationPromise;
}();

exports.ValidationPromise = ValidationPromise;